/**
 * Whether the "Data trace" tier-2 action on a measurement is always shown, or
 * only surfaces once the measurement actually has edits (a crop window or at
 * least one removed datapoint).
 *
 *   false -> action appears only when window is set OR removedPoints.length > 0
 *            (LAUNCH DEFAULT — no noise on untouched measurements)
 *   true  -> action always in the tier-2 menu; with no edits it still shows the
 *            raw-buffer stats (how many points, over what span) as a reference
 *
 * The full data-trace + datapoint restore machinery is built regardless of this
 * flag — it only governs discoverability of the entry point. Intended to be
 * replaced by a PostHog feature flag for a staged rollout once usage is being
 * measured — read it there and fall back to DATAPOINT_TRACE_ALWAYS_VISIBLE.
 */
export const DATAPOINT_TRACE_ALWAYS_VISIBLE = false;
